import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type ProductSearchCache = {
    productSearchQuery : string,
    refinementList : Array<string>,
    sortByIndex : string,
}

type ProductSearchCacheState = {
    productSearchCache : ProductSearchCache;
}

const initialProductSearchCache : ProductSearchCache = {
    productSearchQuery: "",
    refinementList: [],
    sortByIndex: import.meta.env.VITE_ALGOLIA_MAIN_INDEX
}

const initialState : ProductSearchCacheState = {
    productSearchCache : initialProductSearchCache
}

export const productSearchCacheSlice = createSlice({
    name: 'productSearchCache',
    initialState: initialState,
    reducers: {
        setProductSearchQuery: (state, action : PayloadAction<string>) => {
            state.productSearchCache.productSearchQuery = action.payload;
        },
        addToRefinementList: (state, action : PayloadAction<string>) => {
            state.productSearchCache.refinementList.push(action.payload);
        },
        removeFromRefinementList: (state, action : PayloadAction<string>) => {
            const currentState = state.productSearchCache.refinementList;

            const newState = currentState.filter(refinement => refinement !== action.payload);

            state.productSearchCache.refinementList = newState;
        },
        clearRefinementList: (state) => {
            state.productSearchCache.refinementList = [];
        },
        setSortByIndex: (state, action : PayloadAction<string>) => {
            state.productSearchCache.sortByIndex = action.payload;
        },
        resetSortByIndex: (state) => {
            state.productSearchCache.sortByIndex = import.meta.env.VITE_ALGOLIA_MAIN_INDEX;
        },   
    }
});

export const { 
    setProductSearchQuery,
    addToRefinementList,
    removeFromRefinementList,
    clearRefinementList,
    setSortByIndex,
    resetSortByIndex
 } = productSearchCacheSlice.actions;

export default productSearchCacheSlice.reducer;
